import {
  type AlertProps,
  createTheme,
  type PaletteOptions,
} from '@mui/material'
import { alpha } from '@mui/material/styles'
import { createBaseTheme, deleteButtonStyling } from './theme-base'

export { deleteButtonStyling }

const palette = {
  primary: {
    main: '#FFCC11',
    light: '#ffd951',
    dark: '#D5B024',
    contrastText: '#262923',
  },
  secondary: {
    main: '#43485C',
    contrastText: '#ffffff',
  },
  error: {
    main: '#ED1C24',
    light: '#F5D0D1',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#FF8000',
    light: '#FFD4A8',
    contrastText: '#ffffff',
  },
  info: {
    main: '#1991EB',
    light: '#C2DDF1',
    contrastText: '#ffffff',
  },
  success: {
    main: '#008A45',
    light: '#B9DFCC',
    contrastText: '#ffffff',
  },
  text: {
    primary: '#262923',
    secondary: '#78869E',
    disabled: '#26292388',
  },
} satisfies PaletteOptions

const caterpillarTheme = createTheme(createBaseTheme(palette), {
  palette: {
    action: {
      hover: palette.primary.light,
      selected: alpha(palette.primary.main, 0.9),
      focus: alpha(palette.secondary.main, 0.5),
      active: alpha(palette.secondary.main, 0.9),
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        outlinedPrimary: {
          color: palette.primary.contrastText,
          borderColor: palette.primary.contrastText,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        outlinedPrimary: {
          color: palette.primary.contrastText,
          borderColor: palette.primary.contrastText,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { color: palette.text.primary },
        filledError: { backgroundColor: palette.error.light },
        filledInfo: { backgroundColor: palette.info.light },
        filledSuccess: { backgroundColor: palette.success.light },
        filledWarning: { backgroundColor: palette.warning.light },
        icon: (params: { ownerState: AlertProps }) =>
          params.ownerState.variant === 'filled'
            ? {
                color:
                  params.ownerState.severity === 'error'
                    ? palette.error.main
                    : params.ownerState.severity === 'info'
                      ? palette.info.main
                      : params.ownerState.severity === 'success'
                        ? palette.success.main
                        : palette.warning.main,
              }
            : {},
      },
    },
  },
})

export default caterpillarTheme
